<template>
    <div class="workDynamics-wrap">
        <div class="workDynamics">

            <div class="workDynamics-content">

                <div class="workDynamics-left">
                    <!-- <div class="workDynamics-title">
                        <div class="title-left">
                            <span class="workDynamics-title-left">通知公告</span>
                            <div class="title-bottom">
                                <div class="title-divider"></div>
                                <span class="bottom-text">Notice</span>
                            </div>
                        </div>
                        <div class="workDynamics-title-right" @click="goTzgg()">{{`更多>>`}}</div>
                    </div> -->
                    <div class="img-content" v-show="imgShow">
                        <sliders class="sliders" :key="imgWidth" :imgWidth="imgWidth" v-if="images.length > 0" :imgList="images"></sliders>
                        <img v-else class="workDynamics-img" src="../../static/webp1/workDynamics.png" />
                    </div>
                </div>
                <div class="news-right">
                    <div class="workDynamics-title">
                        <div :class="['title-left',{'active-title':activeTitleIndex === 0}]" @click="noticeActive">
                            <span class="workDynamics-title-left">通知公告</span>
                            <div class="title-bottom">
                                <div class="title-divider"></div>
                                <span class="bottom-text">Notice</span>
                            </div>
                        </div>
                        <div :class="['title-left',{'active-title':activeTitleIndex === 1}]" style="margin-left:48px"
                            @click="workActive">
                            <span class="workDynamics-title-left">工作动态</span>
                            <div class="title-bottom">
                                <div class="title-divider"></div>
                                <span class="bottom-text">Work trend</span>
                            </div>
                        </div>

                        <div class="workDynamics-title-right" @click="goJumper()">{{`更多>>`}}</div>
                    </div>
                    <!-- <div class="news-items">
                        <div class="news-item" v-for="(item, index) in itemsList" :key="index">
                            <div v-if="item.title" class="news-content1" @click="jump(item)">
                                <div class="notice-item-content">
                                    <div class="notice-item-content1">
                                        {{ item.title }}

                                    </div>
                                    <div class="notice-item-date">
                                        {{ item.deployTime.substring(0, 10) }}
                                    </div>
                                </div>
                            </div>
                            <div v-else class="news-content1" :style="{display:item.hide?'none':'block'}"
                                @click="jump(item)">
                                <span style="cursor:pointer">s</span>
                            </div>
                        </div>
                    </div> -->
                    <div class="notice-items" v-for="(item, index) in itemsList" :key="index" @click="jumps(item)">
                        <div v-if="item.title" class="notice-item">
                            <div class="notice-item-content" @click="jump(item)">
                                <div class="notice-item-content1">
                                    {{ item.title }}

                                </div>
                                <div class="notice-item-date">
                                    {{ item.deployTime.substring(0, 10) }}
                                </div>
                            </div>
                        </div>
                        <!-- <div v-else  class="notice-item" :style="{display:item.hide?'none':'block'}">
                            <div class="notice-item-content" @click="jump(item)">
                                <span style="cursor:pointer">s</span>
                            </div>

                        </div> -->
                    </div>
                </div>
                <!-- <div class="workDynamics-right">

                    <div class="news-items">
                        <div class="workDynamics-title">
                            <div class="title-left">
                                <span class="workDynamics-title-left">通知公告</span>
                                <div class="title-bottom">
                                    <div class="title-divider"></div>
                                    <span class="bottom-text">Notice</span>
                                </div>
                            </div>
                            <div class="workDynamics-title-right" @click="goTzgg()">{{`更多>>`}}</div>
                        </div>
                        <div class="news-item" style="margin-bottom: 10px;" v-for="(item, index) in tzggList"
                            :key="index">
                            <div class="news-content1" @click="jump(item)">
                                {{ item.title }}
                            </div>

                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import sliders from "./sliders.vue";
export default {
    mounted() {
        GMS.vbus.$on("getId", (res) => {
            this.gzdtId = res.gzdtId;
            this.tzggId = res.tzggId;
            this.getGzdt();
            this.gettzgg();
        });
        window.addEventListener("resize", () => {
            this.imgWidth = window.innerWidth * 0.35 - 40;
        });
    },
    data() {
        return {
            gzdtId: "",
            tzggId: "",
            gzdtList: [],
            tzggList: [],
            pageNum: 1, //当前页码
            pageSize: 8, // 当前页大小
            imgs: "",
            imgShow: false,
            activeTitleIndex: 0,
            gzdtImg: "",
            images: [],
            defaultNum: 8,
            imgWidth: window.innerWidth * 0.35 - 40,
        };
    },
    destroyed() {
        window.removeEventListener("resize", () => {
            this.imgWidth = window.innerWidth * 0.35 - 40;
        });
    },
    computed: {
        itemsList() {
            let list = this.activeTitleIndex === 0 ? this.tzggList : this.gzdtList;
            let result = list.slice(0, this.defaultNum);
            let gap = this.defaultNum - result.length;
            for (let i = 0; i < gap; i++) {
                result.push({ hide: true }); //hide占位用
            }
            return result;
        },
    },
    methods: {
        workActive() {
            this.activeTitleIndex = 1;
        },
        noticeActive() {
            this.activeTitleIndex = 0;
        },
        getDay(value) {
            let date = new Date(value);
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getUTCDate();
            return `${year}年${this.addZero(month)}月${day}日`;
        },
        addZero(time) {
            if (time < 10) {
                return "0" + time;
            } else {
                return time;
            }
        },
        toUrl() {
            window.open(window.osConfig.eproAssetUrl);
        },
        getGzdt() {
            let pram = {
                channels: JSON.stringify([this.gzdtId]),
                filter: JSON.stringify({ deployed: 1 }),
                pageInfo: JSON.stringify({
                    pageNum: 1,
                    pageSize: 8,
                }),
            };
            GMS.$http
                .post("/portal/cms/view/contents", pram, {})
                .then((res) => {
                    if (res.status == 200) {
                        if (res.data.bean.length > 0) {
                            this.gzdtList = res.data.bean;
                            this.fetchGzdtImage(); // 尝试获取前 5 个图片
                            this.imgShow = true;
                        } else {
                        }
                    }
                })
                .catch((error) => {
                    this.imgShow = true;
                    this.$Message.error("获取数据异常，请联系管理员");
                });
        },
        async fetchGzdtImage() {
            for (let i = 0; i < this.gzdtList.length; i++) {
                const item = this.gzdtList[i];
                if (!item) continue;
                try {
                    const res = await GMS.$http.get(`/portal/cms/images?guid=${item.guid}`);
                    if (res.data && res.data.code == 200) {
                        let arr = res.data.datas;
                        console.log("当前图片数组:", res.data);
                        if (arr && arr.length > 0 && this.images.length < 10) {
                            arr.forEach((img) => {
                                console.log("当前图片:", img);
                                this.images.push({
                                    url:img,
                                    title:item.title,
                                    guid:item.guid
                                });
                            });
                        }
                    }
                } catch (e) {
                    // 可以选择打印错误或忽略
                    console.warn(`图片获取失败: index ${i}`, e);
                }
            }
        },
        gettzgg() {
            let pram = {
                channels: JSON.stringify([this.tzggId]),
                filter: JSON.stringify({ deployed: 1 }),
                pageInfo: JSON.stringify({
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                }),
            };
            GMS.$http
                .post("/portal/cms/view/contents", pram, {})
                .then((res) => {
                    if (res.status == 200) {
                        if (res.data.bean.length > 0) {
                            this.tzggList = res.data.bean;
                        } else {
                        }
                    }
                })
                .catch((error) => {
                    this.imgShow = true;
                    this.$Message.error("获取数据异常，请联系管理员");
                });
        },
        //跳转到详情页
        jump(res) {
            console.log('跳转到通知公告详情页',res)
            let Modal = true;
            GMS.$http
                .get(`/portal/cms/content?guid=` + res.guid, {
                
                })
                .then((value) => {
                    console.log('获取详情内容返回信息',value)
                    if (value.status == 200) {
                    const text = value.data.datas.data.text;
                    // Check if text contains "公告挂网地址" and has a URL
                    const urlMatch = text.match(/公告挂网地址：<a href="([^"]*)"[^>]*>([^<]*)<\/a>/i);
                    
                    if (urlMatch && urlMatch[1]) {
                        // Found a URL after "公告挂网地址", redirect to it
                         window.open(urlMatch[1], '_blank');
                    } else {
                        // No matching URL found, throw error which will trigger .catch()
                        throw new Error('No valid announcement URL found in content');
                    }
                    }
                }).catch((error) => {
                    this.jumpDetail(res);
                });
        },
        jumpDetail(res){
            let Modal = true;
            GMS.$http
                .post(`/portal/cms/checkPrivileges?guid=` + res.guid, {
                    userName: JSON.parse(sessionStorage.getItem("person")),
                })
                .then((value) => {
                    if (value.status == 200) {
                        Modal = value.data;
                        if (!Modal) {
                            GMS.vbus.$emit("Modal-Show");
                            return;
                        } else {
                            this.$router.push({
                                path: "/home/detail",
                                query: {
                                    title: res.title,
                                    name: "",
                                    guid: res.guid,
                                    total: res.title,
                                },
                            });
                        }
                    }
                });
        },
        // 返回列表页
        goJumper() {
            if (this.activeTitleIndex === 0) {
                this.goTzgg();
            } else {
                this.goWorker();
            }
        },
        goWorker() {
            let navlist = JSON.parse(sessionStorage.getItem("navList"));
            let item = navlist.find((qwe) => qwe.title === "工作动态");
            if (item && item.childList.length === 0) {
                this.$router.push({
                    path: "/home/solution",
                    query: {
                        id: item.id,
                    },
                });
            } else {
                this.$router.push({
                    path: "/home/solution",
                    query: {
                        id: item.id,
                        tagnum: item.childList[0].ordina,
                    },
                });
            }
        },
        //通知公告列表
        goTzgg() {
            let navlist = JSON.parse(sessionStorage.getItem("navList"));
            let item = navlist.find((qwe) => qwe.title === "通知公告");
            if (item && item.childList.length === 0) {
                this.$router.push({
                    path: "/home/solution",
                    query: {
                        id: item.id,
                    },
                });
            } else {
                this.$router.push({
                    path: "/home/solution",
                    query: {
                        id: item.id,
                        tagnum: item.childList[0].ordina,
                    },
                });
            }
        },
        // 获得第一条数据的图片
        getImg(guid, value) {
            GMS.$http
                .get(`/portal/cms/image?guid=` + guid)
                .then((res) => {
                    if (res.status == 200) {
                        this.imgs = res.data;
                    }
                    this.workerList = value;
                    this.imgShow = true;
                })
                .catch((error) => {
                    this.workerList = value;
                    this.imgShow = true;
                    this.$Message.error("获取数据异常，请联系管理员");
                });
        },
    },
    components: {
        sliders,
    },
};
</script>

<style lang="less" scoped>
.workimg-content {
    height: 33%;
    margin-bottom: 28px;
    position: relative;
}
.newsimg {
    width: 100%;
    height: 100%;
    cursor: pointer;
}
.img-content {
    position: relative;
    height: 100%;
}
.day-text {
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 12px;
    color: #ffffff;
}
.img-divider {
    height: 1px;
    opacity: 0.65;
    border: 0.5px solid #ffffff;
}
.img-div {
    position: absolute;
    bottom: 16px;
    width: 100%;
    padding: 0 24px;
    display: flex;
    flex-direction: column;
}
.img-text {
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    font-size: 18px;
    color: #ffffff;
    margin-bottom: 5px;
}
.workDynamics-wrap {
    width: 100%;
    padding: 30px 15% 45px 15%;
    background-image: url("../../static/webp1/workDynamicsimg.png");
    // .workDynamics {
    //     // width: 1200px;
    // }
    // @media screen and (max-width: 1500px) {
    //     .workDynamics {
    //         // width: 1200px;
    //     }
    // }
    // @media screen and (min-width: 1500px) and (max-width: 1800px) {
    //     .workDynamics {
    //         width: 1400px;
    //     }
    // }
    // @media screen and (min-width: 1800px) {
    //     // .workDynamics {
    //     //     width: 100%;
    //     // }
    // }
    .notice-item {
            width: 100%;
            padding: 7px 0px;
            //border-bottom: 1px solid #d8d8d8;
            .notice-item-content {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 8px;
            }
            .notice-item-content1 {
                cursor: pointer;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 16px;
                color: #424242;
                white-space: nowrap; /* 确保文本在一行内显示 */
                overflow: hidden; /* 超出容器的文本隐藏 */
                text-overflow: ellipsis; /* 超出部分显示省略号 */
            }
            .notice-item-content2 {
                width: 50px;
                height: 10px;
                float: right;
                margin-top: 0px;
                background-size: 50px 20px;
            }
            .notice-item-date {
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 14px;
                color: #424242;
                letter-spacing: 0;
                text-align: right;
                white-space: nowrap;
            }
        }
        .notice-item:hover {
            background-color: rgba(41, 71, 172, 0.05);

            .notice-item-content1,
            .notice-item-date {
                color: #4554af;
            }
        }
    .workDynamics-title {
        height: 55px;
        margin-bottom: 24px;
        display: flex;
        align-items: center;
        position: relative;
        .title-left {
            display: flex;
            flex-direction: column;
            cursor: pointer;
            .title-bottom {
                display: flex;
                align-items: center;
                .title-divider {
                    width: 28px;
                    height: 1px;
                    border: 2px solid #00000073;
                }
                .bottom-text {
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 14px;
                    color: #00000073;
                    margin-left: 10px;
                }
            }
        }
        .workDynamics-title-left {
            opacity: 0.89;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            font-size: 26px;
            letter-spacing: 0;
            line-height: 33px;
            color: #00000073;
        }
        .workDynamics-title-right {
            cursor: pointer;
            opacity: 0.89;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            position: absolute;
            right: 0;
            color: #2947ac;
        }
        .active-title {
            .workDynamics-title-left {
                color: #2947ac;
            }
            .workDynamics-title-right {
                color: #2947ac;
            }
            .title-divider {
                border: 2px solid #e8b138 !important;
            }
            .bottom-text {
                color: #2947ac;
            }
        }
    }
    .workDynamics-content {
        display: flex;
        gap: 30px;
        height: 100%;
        .workDynamics-left {
            position: relative;
            width: 50%;
            // background:url('../../static/webp1/工作动态@2x.webp') no-repeat;
            // background-size: 558px 369px;
            img {
                width: 640px;
                height: 426px;
            }
        }
        .workDynamics-right {
            width: 314px;
            margin-left: 30px;
        }
        .news-right {
            flex: 1;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            .news-items {
                display: flex;
                flex-direction: column;
                line-height: 40px;
                flex: 1;
            }
            // max-width: 314px;
        }
        .workDynamics-right {
            flex: 1;
            overflow: hidden;
            .workDynamics-item {
                cursor: pointer;
                height: 28px;
                margin-bottom: 18px;
                line-height: 28px;
            }
            .workDynamics-item1 {
                margin-top: 17px;
            }
            .workDynamics-item-xh {
                float: left;
            }
            .workDynamics-item-dian {
                float: left;
                width: 4px;
                height: 4px;
                margin-top: 11px;
                margin-left: 4px;
                margin-right: 12px;
                background: #96a2c2;
            }
            .workDynamics-item-xh1 {
                font-family: PingFangSC-Medium;
                font-weight: 500;
                font-size: 20px;
                color: #f55858;
                margin-right: 11px;
            }
            .workDynamics-item-xh2 {
                font-family: PingFangSC-Medium;
                font-weight: 500;
                font-size: 20px;
                color: #f55858;
                margin-right: 9px;
            }
            .workDynamics-item-xh3 {
                font-weight: 500;
                font-size: 20px;
                color: #ff9d00;
                margin-right: 9px;
            }
            .workDynamics-item-content {
                float: left;
                font-size: 18px;
                color: #0f0f0f;
            }
            .workDynamics-item-content1 {
                font-weight: 500;
                font-size: 20px;
                color: #0f0f0f;
            }
            .workDynamics-item-content2 {
                font-weight: 500;
                font-size: 20px;
                color: #0f0f0f;
            }
            .workDynamics-item-content3 {
                font-weight: 500;
                font-size: 20px;
                color: #0f0f0f;
            }
            .workDynamics-item-icon {
                float: left;
            }
            .workDynamics-item-date {
                float: right;
                font-size: 16px;
                color: #999999;
            }
        }
        // @media screen and (max-width: 1500px) {
        //     .workDynamics-left {
        //         width: 758px;
        //         height: 369px;
        //         background-size: 558px 369px;
        //     }
        //     .workDynamics-right {
        //         width: 402px;
        //         margin-left: 30px;
        //     }
        //     .news-left {
        //         float: left;
        //         width: 300px;
        //         height: inherit;
        //         margin-right: 20px;
        //     }
        //     .news-right {
        //         float: left;
        //         width: 320px;
        //         height: inherit;
        //     }
        //     .news-content1 {
        //         max-width: 230px;
        //     }
        //     .news-content1-tzgg {
        //         max-width: 280px;
        //     }
        // }
        // @media screen and (min-width: 1500px) and (max-width: 1800px) {
        //     .workDynamics-left {
        //         width: 846px;
        //         height: 427px;
        //         background-size: 646px 427px;
        //     }
        //     .workDynamics-right {
        //         width: 480px;
        //         margin-left: 58px;
        //     }
        //     .news-left {
        //         float: left;
        //         width: 400px;
        //         height: inherit;
        //         margin-right: 20px;
        //     }
        //     .news-right {
        //         float: left;
        //         width: 420px;
        //         height: inherit;
        //     }
        //     .news-content1 {
        //         max-width: 330px;
        //     }
        //     .news-content1-tzgg {
        //         max-width: 380px;
        //     }
        // }
        // @media screen and (min-width: 1800px) {
        //     .workDynamics-left {
        //         width: 986px;
        //         height: 384px;
        //         background-size: 646px 427px;
        //     }
        //     .workDynamics-right {
        //         width: 314px;
        //         margin-left: 30px;
        //     }
        //     .news-left {
        //         float: left;
        //         width: 640px;
        //         height: inherit;
        //         margin-right: 32px;
        //     }
        //     .news-right {
        //         float: left;
        //         width: 314px;
        //         height: inherit;
        //     }
        //     .news-content1-tzgg {
        //         max-width: 450px;
        //     }
        //     .news-content1 {
        //         max-width: 360px;
        //     }
        // }
    }
    .strong {
        font-weight: 700 !important;
    }
    .workDynamics-img {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }
}
.news-item {
    .news-content1 {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        color: #424242;
        letter-spacing: 0;
        text-align: justify;
        white-space: nowrap; /* 确保文本在一行内显示 */
        overflow: hidden; /* 超出容器的文本隐藏 */
        text-overflow: ellipsis;
    }
    .notice-item-content1 {
        cursor: pointer;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        color: #424242;
        white-space: nowrap; /* 确保文本在一行内显示 */
        overflow: hidden; /* 超出容器的文本隐藏 */
        text-overflow: ellipsis; /* 超出部分显示省略号 */
    }
    .notice-item-date {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #424242;
        letter-spacing: 0;
        text-align: right;
        white-space: nowrap;
    }
    .news-btn {
        cursor: pointer;
        float: right;
        width: 18px;
        height: 18px;
        margin-right: 5px;
    }
}
.zcglxt-bg {
    width: inherit;
    height: 150px;
    background-size: 100% 100%;
    background-image: url("../../static/ligong/xtbg.png");
    margin-bottom: 10px;
    cursor: pointer;
}
.zcglxt-title {
    width: 200px;
    height: 33px;
    font-family: PingFangSC-SNaNpxibold;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #b4720b;
    margin-left: 32px;
}
.news-content1-tzgg {
    float: left;
    cursor: pointer;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 18px;
    color: #393939;
    letter-spacing: 0;
    text-align: justify;
    height: 25px;
    line-height: 25px;
    margin-bottom: 6px;

    white-space: nowrap; /* 确保文本在一行内显示 */
    overflow: hidden; /* 超出容器的文本隐藏 */
    text-overflow: ellipsis;
}
.notice-title {
    height: 33px;
    margin-bottom: 10px;
    margin-top: 10px;
    .notice-title-left {
        float: left;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        font-size: 24px;
        color: #222222;
        letter-spacing: 0;
        line-height: 33px;
    }
    .notice-title-right {
        cursor: pointer;
        float: right;
        width: 62px;
        height: 26px;
        border: 1px solid #e5e5e5;
        border-radius: 14px;
        margin-top: 6px;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        text-align: center;
        line-height: 24px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/workDynamics.vue